<template>
    <ul class="pagination justify-content-center">
        <li v-if="paginaActual !== 1" class="page-item" @click="obtenerPaginaAnterior()">
            <a class="page-link" href="#" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
            </a>
        </li>
        <li class="page-item" v-for="pagina in totalPaginas(datosPop)" :key="pagina" @click="obtenerPaginaActual(pagina)">
            <a class="page-link" href="#">{{pagina}}</a>
        </li>
        <li v-if="totalPaginas() !== paginaActual" class="page-item" @click="obtenerPaginaSiguiente()">
            <a class="page-link" href="#" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
            </a>
        </li>
    </ul>
</template>

<script>


export default{
    emits: ['pagina-actualizada'],
    props: {
        datosPop: Object
    },
    data(){
        return{
            elementosPorPagina: 20,
            datosPag: [],
            paginaActual: 1,
        }
    },
    methods: {
         obtenerPaginaActual(noPagina = 0){
            this.paginaActual = noPagina;
            this.$emit('pagina-actualizada', this.paginaActual);
        },
        totalPaginas(){
            return Math.ceil(this.datosPop.length / this.elementosPorPagina);
        },
        obtenerPaginaAnterior(){
            if(this.paginaActual > 1) this.paginaActual--;
            this.$emit('pagina-actualizada', this.paginaActual);
        },
        obtenerPaginaSiguiente(){
            if(this.paginaActual < this.totalPaginas()) this.paginaActual++;
            this.$emit('pagina-actualizada', this.paginaActual);
        },
        validacionDisponibilidad(pop){
            let totalApartados = null;
            if (pop.apartados) {
                totalApartados = Object.keys(pop.apartados).reduce(
                (suma, indice) => suma + pop.apartados[indice].cantidadApartada, 0);
            }
            return [
                pop.cantidadDisponible - totalApartados ?? 0,
                totalApartados ?? 0,
            ];
        },
        filtrarFigurasDisponibles(pops){
            return pops.filter( 
                pop => 
                this.validacionDisponibilidad(pop)[0] > 0
            )
        
        },
    }  
}


</script>
